<template>
  <ContractorContactTable type="address" />
</template>

<script lang="ts">
import ContractorContactTable from '@/pages/contractor/single/components/ContractorContactTable.vue'

export default {
  name: 'ContractorAddressesTab',
  components: { ContractorContactTable },
}
</script>
